import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: "Sidebar",
    data() {
        return {
            notifications_contracts: 0,
            notifications_cnpros: 0,
            notifications_cnsurveys: 0,
        }
    },
    methods: {
        isActive(page){
            if(page == localStorage.getItem("cn_a_current_page")){
                return "true";
            }
        },
       
    },
    created: function(){
        //this.getNotifications();
        localStorage.setItem("cn_a_current_page", this.$route.path);
    }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/script.js